module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"all":"All","minimum_alert":"Please, select as least 1 store!","stores":"Stores","selectStore":"Select Store","noResults":"No Results","apply":"Apply","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
